import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToasterComponent from 'shared/components/ToasterComponent';

import Parameters from 'wave_solder_pallets/components/Parameters';
import Pricing from 'wave_solder_pallets/components/Pricing';
import { selectDataForApp } from 'wave_solder_pallets/store/selectors';
import { changeParameter, validator } from 'wave_solder_pallets/store/slice';
import { doQuote } from 'wave_solder_pallets/store/thunks';

const App = () => {
  const dispatch = useDispatch();
  const { parameters, quote } = useSelector(selectDataForApp);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    dispatch(doQuote({ name, value }));
  };

  return (
    <div className="container-fluid container-lg pt-4 pt-xl-0">
      <ToasterComponent />
      <div className="row">
        <div className="col-lg-4">
          <div className="card parameters">
            <div className="card-body">
              <Parameters
                parameters={parameters}
                onChangeParameter={onChangeParameter}
                validator={validator} />
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="second-section">
            <div className="container">
              <Pricing parameters={parameters} quote={quote} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
